<template>
  <div>
    <a-row>
      <a-col :span="6" :lg="6" :sm="24" :xs="24">
        <el-card style="margin: 0px 10px 0px 10px; padding: 10px">
          <a-config-provider :locale="zhCN">
            <a-calendar
              v-model:value="selDate"
              :fullscreen="false"
              @select="onSelect"
            />
          </a-config-provider>
        </el-card>
      </a-col>
      <a-col :span="18" :lg="18" :sm="24" :xs="24">
        <el-card style="margin: 0px 10px 0px 10px; padding: 10px">
          <div v-if="etfData" class="etf-info">
            <h3 style="margin-bottom: 20px; color: #1890ff">
              {{ etfData.mod.etfName }} {{ formatDate(etfData.mod.infoTime) }}
            </h3>

            <div class="info-section">
              <h4>前日信息</h4>
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">前日 现金差额</span>
                  <span class="value"
                    >{{ etfData.mod.preCashComponent }} 元</span
                  >
                </div>
                <div class="info-item">
                  <span class="label">前日最小申购、赎回单位净值</span>
                  <span class="value">{{ etfData.mod.naVperCU }} 元</span>
                </div>
                <div class="info-item">
                  <span class="label">前日基金份额净值</span>
                  <span class="value">{{ etfData.mod.nav }} 元</span>
                </div>
              </div>
            </div>

            <div class="info-section">
              <h4>今日信息</h4>
              <div class="info-grid">
                <div class="info-item">
                  <span class="label">预估现金差额</span>
                  <span class="value">{{
                    etfData.mod.estimatedCashComponent
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label">现金替代比例上限</span>
                  <span class="value"
                    >{{ (etfData.mod.maxCashRatio * 100).toFixed(2) }}%</span
                  >
                </div>
                <div class="info-item">
                  <span class="label">最小申购、赎回单位</span>
                  <span class="value">{{
                    etfData.mod.creationRedemptionUnit.toLocaleString() + "份"
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label">当天净申购的基金份额上限</span>
                  <span class="value">{{
                    etfData.mod.creationLimit === 0
                      ? "无限制"
                      : etfData.mod.creationLimit.toLocaleString() + "份"
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label">当天净赎回的基金份额上限</span>
                  <span class="value">{{
                    etfData.mod.redemptionLimit === 0
                      ? "无限制"
                      : etfData.mod.redemptionLimit.toLocaleString() + "份"
                  }}</span>
                </div>

                <div class="info-item">
                  <span class="label"
                    >单个证券账户当天净申购的基金份额上限</span
                  >
                  <span class="value">{{
                    etfData.mod.preCreationLimit === 0
                      ? "无限制"
                      : etfData.mod.preCreationLimit.toLocaleString() + "份"
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label"
                    >单个证券账户当天净赎回的基金份额上限</span
                  >
                  <span class="value">{{
                    etfData.mod.preRedemptionLimit === 0
                      ? "无限制"
                      : etfData.mod.preRedemptionLimit.toLocaleString() + "份"
                  }}</span>
                </div>

                <div class="info-item">
                  <span class="label">当天累计可申购的基金份额上限</span>
                  <span class="value">{{
                    etfData.mod.accCreationLimit === 0
                      ? "无限制"
                      : etfData.mod.accCreationLimit.toLocaleString() + "份"
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label">当天累计可赎回的基金份额上限</span>
                  <span class="value">{{
                    etfData.mod.accRedemptionLimit === 0
                      ? "无限制"
                      : etfData.mod.accRedemptionLimit.toLocaleString() + "份"
                  }}</span>
                </div>

                <div class="info-item">
                  <span class="label"
                    >单个证券账户当天累计可申购的基金份额上限</span
                  >
                  <span class="value">{{
                    etfData.mod.preAccCreationLimit === 0
                      ? "无限制"
                      : etfData.mod.preAccCreationLimit.toLocaleString() + "份"
                  }}</span>
                </div>
                <div class="info-item">
                  <span class="label"
                    >单个证券账户当天累计可赎回的基金份额上限</span
                  >
                  <span class="value">{{
                    etfData.mod.preAccRedemptionLimit === 0
                      ? "无限制"
                      : etfData.mod.preAccRedemptionLimit.toLocaleString() +
                        "份"
                  }}</span>
                </div>

                <div class="info-item">
                  <span class="label">是否开放申购</span>
                  <span
                    class="value"
                    :class="
                      etfData.mod.creationSwitch === 1
                        ? 'status-enabled'
                        : 'status-disabled'
                    "
                  >
                    {{ etfData.mod.creationSwitch === 1 ? "开放" : "关闭" }}
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">是否开放赎回</span>
                  <span
                    class="value"
                    :class="
                      etfData.mod.redemptionSwitch === 1
                        ? 'status-enabled'
                        : 'status-disabled'
                    "
                  >
                    {{ etfData.mod.redemptionSwitch === 1 ? "开放" : "关闭" }}
                  </span>
                </div>
              </div>
            </div>

            <div
              class="info-section"
              v-if="etfData.list && etfData.list.length > 0"
            >
              <h4>成分股列表</h4>
              <el-table
                :data="etfData.list"
                border
                style="width: 100%"
                size="small"
              >
                <el-table-column prop="gpDm" label="代码" />
                <el-table-column prop="gpName" label="证券名称" />
                <el-table-column prop="quantity" label="持仓数量">
                  <template slot-scope="scope">
                    {{ scope.row.quantity.toLocaleString() }}
                  </template>
                </el-table-column>
                <el-table-column prop="substitutionFlag" label="现金替代标志">
                  <template slot-scope="scope">
                    {{ scope.row.substitutionFlag === 1 ? "允许" : scope.row.substitutionFlag === 2 ? "必须" : "未知" }}
                  </template>
                </el-table-column>
                <el-table-column prop="creationPremiumRate" label="申购现金替代溢价比例">
                  <template slot-scope="scope">
                    {{ scope.row.creationPremiumRate * 100 }}%
                  </template>
                </el-table-column>
                <el-table-column prop="creationPremiumRate" label="赎回现金替代折价比例">
                  <template slot-scope="scope">
                    {{ scope.row.redemptionDiscountRate * 100 }}%
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" label="替代金额">
                  <template slot-scope="scope">
                    {{ scope.row.substitutionCashAmount.toLocaleString() }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else class="empty-state">
            <p>请选择日期查看ETF数据</p>
          </div>
        </el-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getEtfPcf } from "@/api/etf";
export default {
  data() {
    return {
      selDate: "2026-06-15",
      zhCN: zhCN,
      etfData: null,
      receivedId: null,
    };
  },
  created() {
    this.receivedId = this.$route.query.id || null;
    const today = new Date();
    this.selDate = today.toISOString().split("T")[0];
    this.GetDate();
  },
  methods: {
    GetDate() {
      getEtfPcf(this.receivedId, this.selDate).then((res) => {
        if (res.code == 0) {
          this.etfData = res.data;
        } else {
          this.etfData = null;
          this.$message.error(res.msg);
        }
      });
    },
    onPanelChange(day, mode) {
      console.log(day, mode);
    },
    onSelect(day) {
      console.log(day);
      this.selDate = day.format("YYYY-MM-DD");
      this.GetDate();
    },
    onSelectPanel(day) {
      console.log(day);
    },
    formatDate(dateNum) {
      const dateStr = dateNum.toString();
      if (dateStr.length !== 8) return dateStr;
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style lang="scss">
.layout-default .ant-layout-content {
  padding-top: 15px;
}
.etf-info {
  .info-section {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    h4 {
      margin: 0 0 15px 0;
      padding: 8px 12px;
      background-color: #f5f5f5;
      border-left: 4px solid #1890ff;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .info-grid {
    border-collapse: collapse;
    width: 100%;
    display: table;
  }

  .info-item {
    display: table-row;
    .label {
      display: table-cell;
      font-size: 13px;
      color: #333;
      padding: 5px 8px;
      border-bottom: 1px dashed #ccc;
      white-space: nowrap;
      text-align: left;
      width: 50%; // 添加宽度设置
    }

    .value {
      display: table-cell;
      font-size: 13px;
      color: #333;
      padding: 5px 8px;
      border-bottom: 1px dashed #ccc;
      text-align: left;
      font-weight: bold;
      width: 50%; // 添加宽度设置
    }
  }

  .status-enabled {
    color: #52c41a !important;
  }

  .status-disabled {
    color: #ff4d4f !important;
  }
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #999;
}

@media (max-width: 768px) {
  .info-grid {
    display: block !important;
  }
  
  .info-item {
    display: block !important;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px dashed #ccc;
  }
  
  .info-item .label,
  .info-item .value {
    display: block !important;
    width: 100% !important;
    padding: 4px 0 !important;
    border-bottom: none !important;
    text-align: left !important;
  }
  
  .info-item .label {
    font-weight: bold;
    color: #666;
  }
  
  .info-item .value {
    font-weight: normal;
  }
}
</style>